<template>
  <div id="app">
    <div class="loader" v-if="$wait.any">
      <p><icon name="spinner" scale="3" spin></icon></p>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
